import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { ThreeDots } from 'react-loader-spinner';
import { Link, useNavigate } from 'react-router-dom';
import moment from 'moment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import SearchIcon from '@mui/icons-material/Search';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import AccountContent from '../account/AccountContent';
import AccountPanel from '../account/AccountPanel';
import { API_BASE_URL } from '../../config/api';

export default function FindAProject() {
    const [projects, setProjects] = useState([]);
    const [count, setCount] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const url = API_BASE_URL;
                const token = localStorage.getItem('authToken');
                const requestOptions = {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                };

                const response = await fetch(
                    `${url}/projects_list?page_num_start=1&page_size=20`,
                    requestOptions
                );
                const data = await response.json();

                if (data.data.projects.length > 0) {
                    setCount(data.data.projectsCount / 10);
                    setPageCount(data.data.projectsCount);
                    setProjects(data?.data?.projects);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const fetchPaginatedData = async (currentPage) => {
        const url = API_BASE_URL;
        setLoading(true);
        const token = localStorage.getItem('authToken');
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        const res = await fetch(
            `${url}/projects_list?page_num_start=${currentPage}&page_size=10`,
            requestOptions
        );
        const data = await res.json();
        setLoading(false);
        return data;
    };

    const handlePageClick = async (data) => {
        const currentPage = data.selected + 1;
        const dataFromServer = await fetchPaginatedData(currentPage);
        setProjects(dataFromServer?.data?.projects);
    };

    return (
        <AccountContent>
            <AccountPanel title="Find a Project" subtitle="Browse available projects and submit your proposals">
                <div className="section_content">
                    {loading ? (
                        <div className="loading_state">
                            <ThreeDots
                                height="60"
                                width="80"
                                radius="9"
                                color="#B1903F"
                                ariaLabel="three-dots-loading"
                                visible={true}
                            />
                            <p>Loading projects...</p>
                        </div>
                    ) : projects.length === 0 ? (
                        <div className="empty_state">
                            <WorkOutlineIcon className="empty_icon" />
                            <h4>No Projects Available</h4>
                            <p>There are no projects available for bidding at the moment. Check back later for new opportunities.</p>
                        </div>
                    ) : (
                        <>
                            <div className="projects_grid">
                                {projects.map((project, index) => (
                                    <div 
                                        key={index} 
                                        className="project_card"
                                        onClick={() => navigate(`/project-details/${project.id}`)}
                                    >
                                        <div className="project_card_header">
                                            <h3 className="project_title">
                                                {project.project_name.length > 60 
                                                    ? `${project.project_name.slice(0, 60)}...` 
                                                    : project.project_name}
                                            </h3>
                                            <Link 
                                                to={`/submitproposal/${project.id}`} 
                                                className="project_status_badge bid_now"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                Bid Now
                                            </Link>
                                        </div>
                                        
                                        <div className="project_card_meta">
                                            <span className="meta_item">
                                                <CalendarTodayIcon />
                                                {moment(project.project_start_date).format("MMM DD, YYYY")}
                                            </span>
                                            <span className="meta_item">
                                                <VisibilityIcon />
                                                {project.bids_count} {project.bids_count === 1 ? 'Bid' : 'Bids'}
                                            </span>
                                        </div>
                                        
                                        <p className="project_description">
                                            {project.project_description.length > 150 
                                                ? `${project.project_description.slice(0, 150)}...` 
                                                : project.project_description}
                                        </p>
                                    </div>
                                ))}
                            </div>

                            {pageCount > 10 && (
                                <div className="pagination_wrapper">
                                    <ReactPaginate
                                        previousLabel={"Prev"}
                                        nextLabel={"Next"}
                                        breakLabel={"..."}
                                        pageCount={count}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={3}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination"}
                                        pageClassName={"page-item"}
                                        pageLinkClassName={"item-link"}
                                        previousClassName={"page-item"}
                                        previousLinkClassName={"item-link"}
                                        nextClassName={"page-item"}
                                        nextLinkClassName={"item-link"}
                                        breakClassName={"page-item"}
                                        breakLinkClassName={"item-link"}
                                        activeClassName={"active"}
                                    />
                                </div>
                            )}
                        </>
                    )}
                </div>
            </AccountPanel>
        </AccountContent>
    );
}